import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { TableShell, Th, Td, EmptyRow } from "@/components/admin/DataTable";

export default function Payments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/payments").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const total = items.reduce((s, p) => s + p.amount, 0);
  return (
    <AdminLayout title="Payments">
      <div className="mb-4 rounded-xl border border-border bg-card p-5"><p className="text-xs text-muted-foreground">Total Collected</p><p className="font-display text-2xl font-extrabold text-primary">{money(total)}</p></div>
      <TableShell>
        <thead className="border-b border-border bg-secondary/40"><tr><Th>Date</Th><Th>Order</Th><Th>Type</Th><Th>Installment</Th><Th>Method</Th><Th>Received By</Th><Th className="text-right">Amount</Th></tr></thead>
        <tbody className="divide-y divide-border">
          {items.length === 0 ? <EmptyRow colSpan={7} /> : items.map((p) => (
            <tr key={p.id} className="hover:bg-secondary/30" data-testid={`payment-row-${p.id}`}>
              <Td>{new Date(p.created_at).toLocaleDateString()}</Td><Td className="font-mono text-xs">{p.order_no}</Td>
              <Td className="capitalize">{p.type}</Td><Td>{p.installment_index > 0 ? `#${p.installment_index}` : "—"}</Td>
              <Td className="capitalize">{p.method}</Td><Td>{p.received_by}</Td><Td className="text-right font-semibold text-primary">{money(p.amount)}</Td>
            </tr>
          ))}
        </tbody>
      </TableShell>
    </AdminLayout>
  );
}
